/** Restricts redirects to same-origin app paths to prevent open redirects. */
export function safeRedirectPath(url: string | undefined): string {
  if (!url) return "/home";
  if (!url.startsWith("/") || url.startsWith("//")) return "/home";
  return url;
}
